"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonType = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importStar(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const hooks_1 = require("../../hooks");
var ButtonType;
(function (ButtonType) {
    ButtonType[ButtonType["Flat"] = 0] = "Flat";
    ButtonType[ButtonType["Secondary"] = 1] = "Secondary";
})(ButtonType || (exports.ButtonType = ButtonType = {}));
function ActionButton({ title, icon, type, action, identifier, isLoading, setLoading, isSyncNotify = false, shouldDeleteOnAction = true, }) {
    const notificationsService = (0, hooks_1.useNotificationsService)();
    const handleAction = () => __awaiter(this, void 0, void 0, function* () {
        if (isSyncNotify && isLoading)
            return;
        action();
        if (isSyncNotify) {
            handleSyncAction();
            return;
        }
        if (shouldDeleteOnAction) {
            yield (notificationsService === null || notificationsService === void 0 ? void 0 : notificationsService.delete(identifier));
        }
    });
    const handleSyncAction = () => {
        if (!!setLoading) {
            setLoading(!isLoading);
            notificationsService === null || notificationsService === void 0 ? void 0 : notificationsService.startContentSync();
        }
        else {
            notificationsService === null || notificationsService === void 0 ? void 0 : notificationsService.ignoreContentSync();
        }
    };
    const flatButton = ((0, jsx_runtime_1.jsxs)(StyledFlatButton, { size: ui_1.ButtonSize.Small, onClick: handleAction, "data-e2e": 'ActionButton_StyledFlatButton', children: [icon && ((0, jsx_runtime_1.jsx)(StyledIcon, { name: icon, height: 24, width: 24, "$loading": isLoading, "data-e2e": 'ActionButton_StyledIcon' })), title] }, type + identifier));
    const secondaryButton = ((0, jsx_runtime_1.jsxs)(StyledSecondaryButton, { size: ui_1.ButtonSize.Small, onClick: handleAction, "data-e2e": 'ActionButton_StyledSecondaryButton', children: [icon && (0, jsx_runtime_1.jsx)(StyledIcon, { name: icon, height: 24, width: 24, "data-e2e": 'ActionButton_StyledIcon' }), title] }, type + identifier));
    return type === ButtonType.Flat ? ((0, jsx_runtime_1.jsx)(Wrapper, { "data-e2e": 'ActionButton_Wrapper', children: flatButton })) : ((0, jsx_runtime_1.jsx)(Wrapper, { "data-e2e": 'ActionButton_Wrapper', children: secondaryButton }));
}
const Wrapper = styled_components_1.default.div `
  display: flex;
  justify-content: flex-start;

  ${ui_1.device.tablet((0, styled_components_1.css) `
    width: 230px;

    &:first-child&:not(:last-child) {
      width: 160px;
    }
  `)};
`;
const StyledSecondaryButton = (0, styled_components_1.default)(ui_1.SecondaryButton) `
  background: transparent;
  font-size: 14px;
  color: ${({ theme }) => theme.designSystem.accent};
  border: 1px solid ${({ theme }) => theme.designSystem.accent};
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 46px;
  text-transform: uppercase;
  word-wrap: break-word;
  margin: 10px 0;
  min-width: fit-content;
  text-align: left;
`;
const StyledFlatButton = (0, styled_components_1.default)(ui_1.FlatButton) `
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.textSecondary};
  font-size: 14px;
  margin: 10px 30px 10px 0;
  min-height: 46px;
  text-transform: uppercase;
  padding: 0;
  white-space: normal;
  min-width: fit-content;
  text-align: left;
`;
const StyledIcon = (0, styled_components_1.default)(ui_1.Icon) `
  margin-right: 5px;
  min-width: 24px;
  min-height: 24px;

  animation: ${({ $loading }) => $loading && 'rotate 0.5s infinite linear'};
  transform: ${({ $loading }) => $loading && 'rotate(90deg)'};

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
exports.default = ActionButton;
